<template>
 <v-form >
   <v-menu
    v-model="menu1"
    :close-on-content-click="false"
    offset-y
    bottom
    content-class="select-outline"
    nudge-top="25px"
    transition="slide-y-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :placeholder="placeholder"
        v-bind:label="label"
        v-model="cmpValue"
        v-bind:rules="rules"
        :class="{
          select: true,
          'input-cinza': true,
          active: menu1,
        }"
        v-bind:required="required"
        v-bind:disabled="disabled"
        outlined
        dense
        v-bind="attrs"
        v-on="on"
        @click:clear="limpar"
        readonly
      >
      </v-text-field>
    </template>
    
    <div class="year-selector">
      <v-divider class="mt-0"></v-divider>
      
      <!-- Grid de anos -->
      <div class="year-grid">
        <v-btn
          v-for="year in years"
          :key="year"
          :class="{ 'selected-year': year == value }"
          :disabled="isYearDisabled(year)"
          @click="selectYear(year)"
          text
          class="year-btn"
          :color="year == value ? 'white' : ''"
        >
          {{ year }}
        </v-btn>
      </div>
      
      <v-divider class="mt-0 mb-3"></v-divider>
      <v-row no-gutters>
        <v-col cols="12" class="pb-3 px-2">
          <v-btn class="w-100" color="primary" @click="anoAtual()">
            <v-icon left>mdi-calendar-check</v-icon> Ano Atual
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-menu>
 </v-form>
</template>

<script>
export default {
  name: "AnoInput",
  props: [
    "value",
    "rules",
    "min",
    "max",
    "placeholder",
    "label",
    "required",
    "disabled",
    "change",
    "prepend-icon"
  ],
  data() {
    return {
      menu1: false,
    };
  },
  computed: {
    cmpValue: {
      get: function () {
        return this.value !== null && this.value !== ""
          ? this.value
          : "";
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
    years() {
      const currentYear = new Date().getFullYear();
      const minYear = this.min ? parseInt(this.min) : currentYear - 50;
      const maxYear = this.max ? parseInt(this.max) : currentYear + 50;
      
      const years = [];
      for (let i = minYear; i <= maxYear; i++) {
        years.push(i);
      }
      return years;
    }
  },
  mounted() {
    // Scroll para o ano selecionado quando o menu abre
    this.$watch('menu1', (isOpen) => {
      if (isOpen) {
        this.$nextTick(() => {
          setTimeout(() => {
            const selectedBtn = document.querySelector('.year-grid .selected-year');
            if (selectedBtn) {
              selectedBtn.scrollIntoView({ behavior: 'auto', block: 'center' });
            } else if (this.value) {
              // Se não encontrar o botão selecionado, tenta rolar para o ano atual
              const currentYearBtn = document.querySelector(`.year-grid .year-btn:nth-child(${this.years.indexOf(parseInt(this.value)) + 1})`);
              if (currentYearBtn) {
                currentYearBtn.scrollIntoView({ behavior: 'auto', block: 'center' });
              }
            }
          }, 50);
        });
      }
    });
  },
  methods: {
    selectYear(year) {
      this.cmpValue = year.toString();
      this.menu1 = false;
      if (this.change) {
        this.change(year.toString());
      }
    },
    isYearDisabled(year) {
      if (this.min && year < parseInt(this.min)) return true;
      if (this.max && year > parseInt(this.max)) return true;
      return false;
    },
    limpar() {
      this.$emit("input", null);
    },
    anoAtual() {
      const ano = this.$moment().format("YYYY");
      
      this.cmpValue = ano;
      this.menu1 = false;
      if (this.change) {
        this.change(ano);
      }
    },
  },
};
</script>

<style>
.input-cinza.active .v-input__slot {
  border-bottom: none;
}

.input-cinza.active fieldset legend {
  width: 0 !important;
}

.year-selector {
  background: white;
  min-width: 280px;
}

.year-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4px;
  padding: 16px;
  max-height: 300px;
  overflow-y: auto;
}

.year-btn {
  height: 40px !important;
  min-width: 80px !important;
  margin: 2px !important;
}

.selected-year {
  background-color: var(--v-primary-base) !important;
  color: white !important;
}
</style>